export const TechsflowLogo = ({ className = "w-40 h-auto inline-block" }) => (
    <img
        src="/techsflow1.png"
        alt="TechsFlow Logo"
        className={className}
    />
);